export const otherCompareIndex = index => (index === 0 ? 1 : 0);

export const subjectsAreEqual = (subject, index, subjects) => {
  const otherSubject = subjects[otherCompareIndex(index)];

  return otherSubject !== null && otherSubject.id === subject.id;
};
